<template>
    <transition name="modal">
        <div id="assignmentToGroup" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-t="'message.action_assignment_to_group'"></div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr>
                            <td class="selected-td" colspan="2">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title" style="width: 100%;">
                                        <span v-if="isTalkgroupSelected">
                                            <div class="inner-panel-title-left" v-t="'message.title_assignment_selectedGroup'"></div>
                                        </span>
                                        <span v-else>
                                            <div class="inner-panel-title-left" v-t="'message.title_assignment_selectedUser'"></div>
                                        </span>
                                    </div>
                                </div>
                                <div id="selected-user" class="inner-panel-dialog" style="height: calc(15vh); width: 100%;">
                                    <div class="selected-item-field">
                                        <span v-for="tag in selectionColumn.data" v-bind:key="tag.id">
                                            <div class="selectedTag">
                                                <span class="selectedTag-name" style="max-width: 100%;">{{ tag.displayName }}</span>
                                                <span class="closeTag"></span>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_move_destination_tree'">
                                        </div>
                                    </div>
                                </div>
                                <div v-if="listType == 0" class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                    <dialogtreemultitype
                                        class="dialog-tree"
                                        v-bind:initialData="tenantList"
                                        @on-selectnode="handleOnSelectNode"
                                        :selection-multi-type="[0]"
                                        ref="dialogTree">
                                    </dialogtreemultitype>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_move_destination_layer'">
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-group" class="inner-panel-dialog" style="height: calc(65vh - 282px);">
                                    <div class="selected-item-field">
                                        <div class="inner-panel-dialog">
                                            <div class="default-message" v-if="showDestinationNodeHint & (destinationNode == null)"  v-t="'message.hint_selection_move_destination'">
                                            </div>
                                            <div v-if="destinationNode != null" class="userTag">
                                                <span class="userTag-name">{{ destinationGroupName }}</span>
                                                <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="moveSelected()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue";
import DialogTreeMultiType from './DialogTreeMultiType.vue';
import commonUtil from './commonutil.js';
import constants from './constants.js';

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_SPEECH_TO_TEXT = -2;
const STATUS_UNMATCH_TRANSLATION = -3;
const STATUS_UNMATCH_MAPTALK = -4;
const STATUS_UNMATCH_VIDEO = -5;
const STATUS_TOO_MANY_TAGS = -6;
const STATUS_LINK_GROUP = -7;

export default {
    components: {
        dialogtree: DialogTree,
        dialogtreemultitype: DialogTreeMultiType
    },

    props: ['appData','userAttribute','selectionColumn'],

    data() {
        return {
            existExternalGroup: false,
            tenantList: [],
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundGroupList: [],
            foundUserList: [],
            listType: 0,
            condition: "groupId",
            conditionUser: "name",
            searchString: null,
            disableSave: true,
            isTalkgroupSelected: true,
            talkgroupAttributeTotal: {},
            userAttributeTotal: {},
            destinationGroupName: null,
            showDestinationNodeHint: true,
            destinationNode: null
        };
    },

    created: function() {
        this.disableSave = true;
        this.tenantList = [];
        this.tenantList.push(this.appData.tenantList[0]);
        if(this.selectionColumn.type == constants.TABLE_OPTIONS.group.value){
            this.isTalkgroupSelected = true;
        }else{
            this.isTalkgroupSelected = false;
        }
    },

    // updated: function() {
    //     if (this.scrollOnAction) {
    //         let obj = document.getElementById("selected-user");
    //         obj.scrollTop = obj.scrollHeight;
    //         this.scrollOnAction = false;
    //     }
    // },

    methods: {
        handleOnSelectNode(data,selectedNode) {
            let self = this;
            server.post('/getinfo', {tenantId: this.appData.tenantList[0].tenantId, id: selectedNode.node.data.id})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let acl = JSON.parse(res.data.acl)
                            if (acl.rw == null) {
                                commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                return;
                            } else {
                                for (var i = 0 ; i< acl.rw.length ; i++) {
                                    if (acl.rw[i].split("-")[1] == self.appData.loginUserObjectId) {
                                        break;
                                    }
                                }
                                if (i == acl.rw.length) {
                                    commonUtil.notifyMessage(self,"Warning", commonUtil.getMessageText(self.$i18n,"error_cannot_select_no_writable_layer"));
                                    return;
                                }
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                            return;
                    }
                    if (data.id == 1) {
                        self.destinationGroupName = data.label
                    } else {
                        let parentNode = selectedNode;
                        let nodeName = parentNode.node.data.label;
                        let array = []
                        while (parentNode.node.data.id != 1) {
                            if (data.type == constants.OBJECT_NODE) {
                                array.push(parentNode.node.data.label);
                            }
                            parentNode = parentNode.$parent;
                            nodeName = parentNode.node.data.label;
                        }
                        array.push(parentNode.node.data.label)   // add root node name
                        let groupName = ""
                        for (let i = (array.length-1) ; i >= 0 ; i--) {
                            if (groupName != "") {
                                groupName = groupName + "/"
                            }
                            groupName = groupName + array[i]
                        }
                        self.destinationGroupName = groupName
                    }
                    if (self.destinationNode == null) {
                        self.setDestinationNodeAfterRedraw(data);
                    } else {
                        self.destinationNode = data
                        self.disableSave = false;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },
        removeUserTag: function(tag) {
            this.$data.destinationNode = null;
            this.disableSave = true;
        },
        setDestinationNodeAfterRedraw(node) {
            // hint of destination node was remained after select the destination node..
            // it can clear by redraw
            this.showDestinationNodeHint = false;
            let self = this;
            this.$nextTick(() => {
                self.showDestinationNodeHint = true;
                self.destinationNode = node;
                self.disableSave = false;
            })
        },




        moveSelected() {
            this.$emit('save' , this.selectionColumn.data, this.destinationNode.id);
        },

        isEnableSave(tenantId) {
            if (tenantId === this.appData.tenantList[0].tenantId) {
                return true;
            }
            for (let exportedTenant of this.appData.exportedTenantList) {
                if (exportedTenant.tenantId === tenantId) {
                    return false;
                }
            }
            return false;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}
.dialog-tree >>> .el-tree-node__content {
    min-height: 40px !important;
    height: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    text-align: justify;
}
.dialog-tree >>>.el-tree-node__expand-icon {
    padding: 0px 28px !important;
}
.selected-td {
    width: 100%;
    vertical-align: top;
    margin: 0;
    padding: 0;
}
.selectedTag {
  display: inline-block;
  border: 1px solid;
  border-radius: 30px;
  border-color: #1F2E4B;
  color: #1F2E4B;
  margin: 5px;
  padding: 6px 10px;
  white-space: nowrap;
  word-break: break-word;
  text-align: justify;
}
.selectedTag > .selectedTag-name {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  max-width: 100%;
}
</style>

